import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AccountModel} from "../../../../../domain/models/account.model";
import {MatTab, MatTabGroup, MatTabContent} from "@angular/material/tabs";
import {PropertiesTabComponent} from "../components/properties-tab/properties-tab.component";
import {AccountReceiptsTabComponent} from "../components/account-receipts-tab/account-receipts-tab.component";
import {AccountBankingTabComponent} from "../components/account-banking-tab/account-banking-tab.component";
import {AccountNotesTabComponent} from "../components/account-notes-tab/account-notes-tab.component";
import {AccountAttachmentsTabComponent} from "../components/account-attachments-tab/account-attachments-tab.component";
import {AccountHistoryTabComponent} from "../components/account-history-tab/account-history-tab.component";
import {BillingTabComponent} from "../components/billing-tab/billing-tab.component";
import {AccountMgmtProfileComponent} from "../../../../../common/account-mgmt-profile/account-mgmt-profile.component";
import {Icons} from "../../../../../domain/enums/icons-enums";
import {CustomerFormComponent} from "../components/customer-form-component";
import {AccountReturnsTabComponent} from "../components/account-returns-tab/account-returns-tab.component";

@Component({
  selector: 'app-account-detail-mgmt-company',
  standalone: true,
  imports: [
    MatTabContent, // lazy <ng-template matTabContent> for RETURNS — without it the tab rendered empty
    MatTab,
    MatTabGroup,
    PropertiesTabComponent,
    AccountReceiptsTabComponent,
    AccountBankingTabComponent,
    AccountNotesTabComponent,
    AccountAttachmentsTabComponent,
    AccountHistoryTabComponent,
    BillingTabComponent,
    AccountMgmtProfileComponent,
    AccountReturnsTabComponent
  ],
  templateUrl: './account-detail-mgmt-company.component.html',
  styleUrl: './account-detail-mgmt-company.component.css'
})
export class AccountDetailMgmtCompanyComponent implements CustomerFormComponent {
  @Input() account!: AccountModel;
  /** Set from the URL so returning to this account lands on the tab it was left on. */
  @Input() selectedIndex = 0;
  @Output() selectedTab = new EventEmitter<number>();
  @ViewChild(AccountMgmtProfileComponent) profile!: AccountMgmtProfileComponent;
  icons = Icons;

  getUpdatedAccount(): AccountModel {
    return this.profile.getUpdatedAccount();
  }

  isFormValid(): boolean {
    return this.profile.isFormValid();
  }

  raiseFormValidations(): void {
    this.profile.raiseFormValidations();
  }
}
